import React from "react";
import InstituteFeesView from "@/pages/public/_shared/InstituteFeesView";
import { useMitsol } from "./MitsolLayout";

export default function MitsolFees() {
  const data = useMitsol() || {};
  const instId = data?.institute?.id || "";
  return (
    <div data-testid="mitsol-fees">
      <div className="bg-gradient-to-r from-[#0F2A47] via-[#123055] to-[#0F2A47] text-white">
        <div className="max-w-6xl mx-auto px-5 py-12">
          <div className="text-[10px] uppercase tracking-[0.35em] font-bold text-[#F97316]">Know Your Fees</div>
          <h1 className="font-serif text-3xl sm:text-4xl mt-2">Fee Structure</h1>
          <p className="mt-2 text-white/80 text-sm max-w-2xl">Transparent, category-wise fee tables. Data is published and maintained by the Trust admin office.</p>
        </div>
      </div>
      <InstituteFeesView instituteId={instId} testidPrefix="mitsol-fees" />
    </div>
  );
}
